
import {defineComponent,PropType} from "vue"
import SelectFilter from "@/components/filters/SelectFilter.vue"
import NumberFilter from "@/components/filters/NumberFilter.vue";
import {IFilter} from "@/services/filters/types/IFilter";

export default defineComponent({
  components: {
    SelectFilter,
    NumberFilter,
  },
  props: {
      filters: {
        required: true,
        type: Object as PropType<IFilter[]>
      }
  }
})
